import ContratoApi from './Services/ContratoApi'

export default {
  ContratoApi,
}
